exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tracking-map-wrapper{border-top:2px solid var(--default-brand-btn-bg-colour)}", ""]);

// exports
